var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full relative"},[_c('canvas',{ref:"chartCanvas",style:({width: '50pc'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }